import i18next from 'i18next';
import TimeSelectBox from 'components/molecules/time-select-box';
import BaseTableActions from 'components/atoms/base-table/actions';

import type { IAdherenceSettingQueueLimit } from 'infrastructure/interfaces';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';

const prepareVal = (num: number) => (num > 9 ? `${num}:00` : `0${num}:00`);

interface IProps {
  onEdit: (rec: IAdherenceSettingQueueLimit) => void;
}

export const columns = ({
  onEdit,
}: IProps): IBaseTableColumns<IAdherenceSettingQueueLimit> => {
  return [
    {
      label: i18next.t('labels.from'),
      key: 'from',
      render: (_, rec) => {
        return (
          <TimeSelectBox readonly plaintext value={prepareVal(rec.from)} />
        );
      },
    },
    {
      label: i18next.t('labels.to'),
      key: 'to',
      render: (_, rec) => {
        return <TimeSelectBox readonly plaintext value={prepareVal(rec.to)} />;
      },
    },
    {
      label: i18next.t('labels.limit'),
      key: 'limit',
    },
    {
      label: i18next.t('labels.actions'),
      key: 'actions',
      align: 'center',
      width: '40px',
      render: (_, record) => <BaseTableActions onEdit={() => onEdit(record)} />,
    },
  ];
};
